module.exports = __webpack_public_path__ + "static/media/ac.8d84843d.png";